import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

const perguntasPadrao = [
  { id: 'alergias', label: 'Alergias' },
  { id: 'medicamentos', label: 'Medicamentos em uso' },
  { id: 'doencas', label: 'Doenças pré-existentes' },
  { id: 'cirurgias', label: 'Já fez cirurgias?' },
  { id: 'tabagismo', label: 'Tabagismo' },
  { id: 'alcool', label: 'Consumo de álcool' },
  { id: 'gestante', label: 'Gestante?' },
  { id: 'observacoes', label: 'Observações gerais' }
];

const ModalAnamnese = ({ open, onClose, onSave, paciente }) => {
  const [respostas, setRespostas] = useState({});

  const handleChange = (id, value) => {
    setRespostas(prev => ({ ...prev, [id]: value }));
  };

  const handleSalvar = () => {
    if (onSave) onSave(respostas);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Anamnese Odontológica</DialogTitle>
      <DialogContent>
        <div style={{ marginBottom: 12 }}>
          <strong>Paciente:</strong> {paciente?.nome || 'Não selecionado'}
        </div>
        {perguntasPadrao.map(q => (
          <TextField
            key={q.id}
            label={q.label}
            value={respostas[q.id] || ''}
            onChange={e => handleChange(q.id, e.target.value)}
            fullWidth
            margin="normal"
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSalvar} variant="contained" color="primary">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAnamnese;
